// extracted by mini-css-extract-plugin
export default {"form":"Form_form__gjyi8","formCont":"Form_formCont__ChYXo","formTitle":"Form_formTitle__0bgpt"};